import { render, staticRenderFns } from "./UserTextMessages.vue?vue&type=template&id=34674bf1&scoped=true&"
import script from "./UserTextMessages.vue?vue&type=script&lang=js&"
export * from "./UserTextMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34674bf1",
  null
  
)

export default component.exports